import { useState, useEffect } from 'react'
import { KTCard, KTCardBody } from '../../../_metronic/helpers'
import searchicon from '../../../_metronic/images/hd_search.svg'
import { UsersListPagination } from '../../modules/apps/user-management/users-list/components/pagination/UsersListPagination'
import { Dropdown, Spinner } from 'react-bootstrap'
import { renderTableData, renderTableHeader } from './SearchListUtils'
import { dropdownMenuItemsType } from './SearchList.types'

interface filterOptions {
  searchText?: string
  perPage?: number
  page?: number
}

interface searchList {
  listCount: number
  paginatedCount: number
  selectedCount?: number
  filterOptions: any
  cardHeader?: any
  setFilterOptions: any
  listLoading: boolean
  toolbar?: any
  isSearchable?: boolean
  apiData: any
  listConfigs: any
  dropdownMenuItems?: dropdownMenuItemsType[]
  onRowClick?: any
  idFieldName: string
  customData?: any
  isActiveApiFieldName: string
  searchKey?: string
  solarProduct?: boolean
  PlaceholderText?: string
  IsSmartDocsList?: boolean
}


export default function SearchList({
  listCount = 0,
  paginatedCount = 0,
  selectedCount = 0,
  filterOptions,
  setFilterOptions,
  listLoading,
  toolbar,
  isSearchable = true,
  apiData,
  listConfigs,
  dropdownMenuItems,
  cardHeader,
  onRowClick,
  idFieldName,
  isActiveApiFieldName = '',
  searchKey = 'searchText',
  PlaceholderText,
  solarProduct,
  IsSmartDocsList = false,
}: searchList) {
  const [page, updatePage] = useState<any>(0)
  const updateRowsPerPage = (value: number) => {
    setFilterOptions((prevOptions: any) => {
      return { ...prevOptions, perPage: value, page: 1 }
    })
  }
  useEffect(() => {
    setFilterOptions((prevOptions: filterOptions) => {
      return { ...prevOptions, page: page + 1 }
    })
  }, [page])

  return (
    <KTCard>
      <div className='card card-custom'>
        {Boolean(cardHeader) || (
          <div className='card-header card-body pb-0 border-0'>
            <div className='card-title'>
              {isSearchable && (
                <div className='d-flex align-items-center position-relative my-1'>
                  <input
                    type='text'
                    data-kt-ecommerce-order-filter='search'
                    className='form-control form-control-solid w-250px pe-14'
                    placeholder={PlaceholderText || 'Search'}
                    onChange={(e) =>
                      setFilterOptions((prev: filterOptions) => {
                        updatePage(0)
                        return { ...prev, [searchKey]: e.target.value, page: page + 1 }
                      })
                    }
                  />
                  <span className='svg-icon svg-icon-1 position-absolute me-4' style={{ right: 0 }}>
                    <img src={searchicon} alt='search' />
                  </span>
                </div>
              )}
              {Boolean(cardHeader) && cardHeader}
              {/* selectedCount>0?(<div className='fs-6 fw-bold text-black'>{`${selectedCount} Report(s) Selected`}</div>):(<div className='fs-6 fw-bold text-black'>{`Showing ${paginatedCount} of ${listCount} Reports`}</div> */}
            </div>
            {toolbar && (
              <div className='card-toolbar flex-row-fluid justify-content-end gap-5'>{toolbar}</div>
            )}
          </div>
        )}

        <KTCardBody className='pe-0 py-0 min-h-400px' scroll>
          {listLoading ? (
            <div className='text-center'>
              <Spinner animation='border' className='text-gray-600 text-center' role='status'>
                <span className='visually-hidden'>Loading...</span>
              </Spinner>
            </div>
          ) : listCount !== 0 ? (
            <div className='table-responsive-xl '>
              <table className='table table-row-dashed gy-7 gs-7'>
                <thead>
                  <tr className='fw-bold fs-6 text-gray-700 border-bottom-2 border-gray-200'>
                    {listConfigs.map((config: any) =>
                      renderTableHeader(config, selectedCount, paginatedCount)
                    )}
                  </tr>
                </thead>
                <tbody>
                  {apiData &&
                    apiData?.map((apiDataValues: any) => {
                      return (
                        <tr
                          key={apiDataValues.id}
                          className={`border-bottom-2 ${onRowClick && !IsSmartDocsList ? 'cursor-pointer' : ''
                            }`}                        >
                          {listConfigs.map((config: any) => {
                            const isDocumentName = config.apiFieldName === 'documentName'
                            return (
                              <td
                                key={config.apiFieldName}
                                className={`text-gray-500 ps-0 fs-6 fw-semibold ${(isDocumentName && IsSmartDocsList) ? 'cursor-pointer text-primary text-hover-underline' : ''
                                  }`}
                                onClick={() => {
                                  if (isDocumentName && IsSmartDocsList) {
                                    onRowClick(apiDataValues)
                                  }
                                  else if (onRowClick && !IsSmartDocsList) {
                                    onRowClick(apiDataValues)
                                  }
                                }}
                              >
                                {renderTableData(apiDataValues, config)}
                              </td>
                            )
                          })}

                          {dropdownMenuItems && (
                            <td className='content'>
                              <Dropdown className='show-override'>
                                <Dropdown.Toggle
                                  id='dropdown-custom-1'
                                  className='text-gray-600 btn btn-sm btn-icon btn-active-light-primary btn-light-primary btn-arrow-overide'
                                  style={{ background: 'none!important' }}
                                >
                                  <i className='bi bi-three-dots-vertical fs-7 text-primary'></i>
                                </Dropdown.Toggle>
                                <Dropdown.Menu className='py-2 menu-state-bg-primary'>
                                  {dropdownMenuItems.map((item: dropdownMenuItemsType, index) => (
                                    <Dropdown.Item
                                      as='div'
                                      key={index}
                                      className='text-gray-600 fs-7 menu-item p-0'
                                      onClick={() =>
                                        item.callBack(
                                          apiDataValues[idFieldName],
                                          item.name.toLowerCase(),
                                          apiDataValues
                                        )
                                      }
                                    >
                                      <div className={`menu-link ${item?.textColor}`}>
                                        {item.name === 'ACTIVATION'
                                          ? apiDataValues[isActiveApiFieldName]
                                            ? 'Inactivate'
                                            : 'Activate'
                                          : item.name}
                                      </div>
                                    </Dropdown.Item>
                                  ))}
                                </Dropdown.Menu>
                              </Dropdown>
                            </td>
                          )}
                        </tr>
                      )
                    })}
                </tbody>
              </table>
            </div>
          ) : (
            <div className='fs-4 mt-4 fw-semibold text-center align-items-center text-muted min-h-400px d-flex-align-items-center justify-content-center'>
              <div>No Results Found</div>
            </div>
          )}
        </KTCardBody>
        {listCount > 0 ? (
          <div className='card-footer border-0'>
            <UsersListPagination
              page={page}
              total={listCount}
              updatePage={updatePage}
              recordsPerPage={(e: any) => {
                updateRowsPerPage(parseInt(e))
              }}
              rowsPerPage={filterOptions.perPage}
            />
          </div>
        ) : (
          <></>
        )}
      </div>
    </KTCard>
  )
}
